export { default as MapInsertAsset } from './MapInsertAsset';
